import { buildSlice, CommonState } from '~libs/reduxUtils';

import { getAll, getOne, typePrefix } from '~lookups/actions/shifts';

import { Shift } from '../models';

type State = CommonState<Shift>;

const initialState: State = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
};

const slice = buildSlice<State, Shift>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
});

export const { clear, updateParams } = slice.actions;
export default slice.reducer;
